import * as React from "react";
import { apiGet } from "./util";
import { ProposalsContext } from "./ProposalsContext";
import { NonFinalizedProposals } from "./NonFinalizedProposals";
import { FinalizedProposals } from "./FinalizedProposals";
import { useEffect, useState } from "react";
import { ErrorMessage } from "./ErrorMessage";
import { IProposalLists } from "./interfaces";

// @ts-ignore
import css from "./sitrep-admin.module.scss";

export const SitrepAdmin: React.FC<{}> = () => {

    const [ error, setError, ] = useState();
    const [ lists, setLists ] = useState<IProposalLists>({
        finalized: [],
        nonFinalized: [],
    });

    async function load() {
        try {
            const lists = await apiGet<IProposalLists>("/proposal-lists");
            const { finalized, nonFinalized, } = lists;
            setLists({ finalized, nonFinalized });
        } catch (err) {
            setError(err.message);
        }
    }

    useEffect(() => {
        load();
    }, []);

    return (
        <ProposalsContext.Provider value={ {
            lists,
            updateLists(lists) { setLists(lists); }
        } }>
            <div className={ css.wrapper }>
                <div className="row" id="header">
                    <div className="col-xs-12">
                        <h2>Sitrep admin</h2>
                    </div>
                </div>

                <ErrorMessage message={ error }/>
                <NonFinalizedProposals/>
                <FinalizedProposals/>
            </div>
        </ProposalsContext.Provider>
    );
};
